import React from 'react'
import { workOrders } from '../../core/controllers/WorkOrders';
import NavLink from '../Routes/NavLink';

export default class WorkOrdersNewRequestCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            count: 0
        }
    }

    componentDidMount() {
        var self = this;
        workOrders.getWorkOrders("LastSevenDays", null, function(response){
            if (response.data != null) {
                self.setState({
                    count: response.data.length
                });
            }
        });
    }

    componentWillUpdate(nextProps, nextState) {
    }

    render(){
        const count = this.state.count;

        if (this.props.clickable == true) {
            return (
                <div class="col-md-3 col-sm-6 col-xs-12">
                    <NavLink to={"/maintenance?filter=LastSevenDays"}>
                    <div class="info-box">
                        <span class="info-box-icon blue-icon-circle"><i class="icon-browser-wrench"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text">New Requests</span>
                            <br/>
                            <span class="info-box-subtext">Over the last 7 days</span>
                            <span class="info-box-number blue-info-number">{ count }</span>
                        </div>
                    </div>
                    </NavLink>
                </div>
            )
        } else {
            return (
                <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="info-box">
                        <span class="info-box-icon blue-icon-circle"><i class="icon-browser-wrench"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text">New Requests</span>
                            <br/>
                            <span class="info-box-subtext">Over the last 7 days</span>
                            <span class="info-box-number blue-info-number">{ count }</span>
                        </div>
                    </div>
                </div>
            )
        }
    }
};


// WEBPACK FOOTER //
// app/components/WorkOrders/WorkOrdersNewRequestCard.jsx